import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import API from "../api";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/style.css";

const Customers = () => {
    const navigate = useNavigate();

    const [customers, setCustomers] = useState([]);

    // SEARCH
    const [search, setSearch] = useState("");

    // LIMIT
    const [limit, setLimit] = useState(10);

    // PAGE
    const [page, setPage] = useState(1);

    const [form, setForm] = useState({
        name: "",
        gstNumber: "",
        phone: "",
        address: "",
        state: ""
    });

    const [editingId, setEditingId] = useState(null);

    const [showModal, setShowModal] = useState(false);

    // GET DATA
    const fetchCustomers = async () => {
        try {
            const res = await API.get("/customers");
            setCustomers(res.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchCustomers();
    }, []);

    // INPUT CHANGE
    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    // SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {

            if (editingId) {
                await API.put(`/customers/${editingId}`, form);
                toast.success("Customer Updated");
            } else {
                await API.post("/customers", form);
                toast.success("Customer Added");
            }

            setForm({
                name: "",
                gstNumber: "",
                phone: "",
                address: "",
                state: "",
            });

            setEditingId(null);
            setShowModal(false);

            fetchCustomers();

        } catch (error) {
            console.log(error);
        }
    };

    // EDIT
    const handleEdit = (item) => {

        setForm({
            name: item.name,
            gstNumber: item.gstNumber || "N/A",
            phone: item.phone,
            address: item.address,
            state: item.state
        });

        setEditingId(item._id);
        setShowModal(true);
    };

    // DELETE
    const handleDelete = async (id) => {

        if (!window.confirm("Delete Customer?")) return;

        try {

            await API.delete(`/customers/${id}`);

            toast.success("Customer Deleted");

            fetchCustomers();

        } catch (error) {
            console.log(error);
        }
    };

    // SEARCH FILTER
    const filtered = customers.filter((c) => {

        const keyword = search.toLowerCase();

        return (
            c.name?.toLowerCase().includes(keyword) ||
            c.phone?.toLowerCase().includes(keyword) ||
            c.address?.toLowerCase().includes(keyword) ||
            c.state?.toLowerCase().includes(keyword)
        );
    });

    // PAGINATION
    const perPage = Number(limit);

    const start = (page - 1) * perPage;

    const current = filtered.slice(start, start + perPage);

    const totalPages = Math.ceil(filtered.length / perPage);

    return (
        <Layout>

            <ToastContainer position="top-right" autoClose={3000} />

            {/* TOPBAR */}
            <div className="topbar">

                <h2>Customer List</h2>

                <button
                    className="add-btn"
                    onClick={() => {

                        setShowModal(true);

                        setEditingId(null);

                        setForm({
                            name: "",
                            phone: "",
                            address: "",
                            state: "",
                        });

                    }}
                >
                    + Add Customer
                </button>
            </div>

            <div className="table-section">

                {/* SEARCH + LIMIT */}
                <div className="table-controls">

                    <div>
                        Show

                        <select
                            value={limit}
                            onChange={(e) => setLimit(e.target.value)}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                        </select>

                        entries
                    </div>

                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(1);
                        }}
                    />
                </div>

                {/* TABLE */}
                <div className="table-responsive">

                    <table className="customers-table">

                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>CUSTOMER NAME</th>
                                <th>GST NUMBER</th>
                                <th>PHONE</th>
                                <th>ADDRESS</th>
                                <th>STATE</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>

                        <tbody>

                            {current.map((item, index) => (

                                <tr key={item._id}>

                                    <td>{start + index + 1}</td>

                                    <td>{item.name}</td>

                                    <td>{item.gstNumber || "N/A"}</td>

                                    <td>{item.phone}</td>

                                    <td>{item.address}</td>

                                    <td>{item.state}</td>

                                    <td>
                                        <div className="actions">

                                            <button
                                                className="view-btn"
                                                onClick={() =>
                                                    navigate(`/customer-history/${item._id}`, {
                                                        state: { customer: item }
                                                    })
                                                }
                                            >
                                                <FaEye />
                                            </button>

                                            <button
                                                className="edit-btn"
                                                onClick={() => handleEdit(item)}
                                            >
                                                <FaEdit />
                                            </button>

                                            <button
                                                className="delete-btn"
                                                onClick={() => handleDelete(item._id)}
                                            >
                                                <FaTrash />
                                            </button>

                                        </div>
                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

                {/* PAGINATION */}
                <div className="pagination">

                    <button
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {Array.from(
                        { length: totalPages },
                        (_, i) => (
                            <button
                                key={i}
                                className={page === i + 1 ? "active" : ""}
                                onClick={() => setPage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        )
                    )}

                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>

            </div>

            {/* MODAL */}
            {showModal && (

                <div className="modal-overlay">

                    <div className="modal">

                        <div className="modal-header">

                            <h3>
                                {editingId ? "Update Customer" : "Add Customer"}
                            </h3>

                            <span onClick={() => setShowModal(false)}>×</span>

                        </div>

                        <form onSubmit={handleSubmit}>

                            <input
                                type="text"
                                name="name"
                                placeholder="Customer Name"
                                value={form.name}
                                onChange={handleChange}
                                required
                            />

                            <input
                                type="text"
                                name="gstNumber"
                                placeholder="GST Number"
                                value={form.gstNumber}
                                onChange={handleChange}
                            />

                            <input
                                type="text"
                                name="phone"
                                placeholder="Phone"
                                value={form.phone}
                                onChange={handleChange}
                                required
                            />

                            <input
                                type="text"
                                name="address"
                                placeholder="Address"
                                value={form.address}
                                onChange={handleChange}
                            />

                            <input
                                type="text"
                                name="state"
                                placeholder="State"
                                value={form.state}
                                onChange={handleChange}
                            />

                            <div className="modal-actions">

                                <button
                                    type="button"
                                    className="cancel-btn"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>

                                <button type="submit" className="create-btn">
                                    {editingId ? "Update" : "Create"}
                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            )}

        </Layout>
    );
};

export default Customers;
